function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("rect", {
  width: 36,
  height: 24,
  rx: 2,
  fill: "#ccc"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#999",
  d: "M0 4h36v4H0z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M2 10h20v4H2z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fill: "#999",
  d: "M24 10h10v4H24z"
});

var _ref5 = /*#__PURE__*/React.createElement("circle", {
  cx: 6,
  cy: 6,
  r: 6,
  transform: "translate(30 6)",
  fill: "#707070"
});

var _ref6 = /*#__PURE__*/React.createElement("tspan", {
  x: 0,
  y: 0
}, "123");

function SvgIconCvc(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 24
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, /*#__PURE__*/React.createElement("text", {
    transform: "translate(31.837 14)",
    fill: "#fff",
    fontSize: 5,
    fontFamily: "Roboto-Bold, Roboto",
    fontWeight: 700,
    style: {
      isolation: "isolate"
    }
  }, _ref6));
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI0MiIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDQyIDI0Ij48cmVjdCB3aWR0aD0iMzYiIGhlaWdodD0iMjQiIHJ4PSIyIiBmaWxsPSIjY2NjIi8+PGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMCA0KSI+PHJlY3Qgd2lkdGg9IjM2IiBoZWlnaHQ9IjQiIGZpbGw9IiM5OTkiLz48L2c+PGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMiAxMCkiPjxyZWN0IHdpZHRoPSIyMCIgaGVpZ2h0PSI0IiBmaWxsPSIjZmZmIi8+PC9nPjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDI0IDEwKSI+PHJlY3Qgd2lkdGg9IjEwIiBoZWlnaHQ9IjQiIGZpbGw9IiM5OTkiLz48L2c+PGNpcmNsZSBjeD0iNiIgY3k9IjYiIHI9IjYiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDMwIDYpIiBmaWxsPSIjNzA3MDcwIi8+PGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTg1NC4zMDYgLTg2MS4wODkpIiBzdHlsZT0iaXNvbGF0aW9uOmlzb2xhdGUiPjx0ZXh0IHRyYW5zZm9ybT0idHJhbnNsYXRlKDg4Ni4xNDMgODc1LjA4OSkiIGZpbGw9IiNmZmYiIGZvbnQtc2l6ZT0iNSIgZm9udC1mYW1pbHk9IlJvYm90by1Cb2xkLCBSb2JvdG8iIGZvbnQtd2VpZ2h0PSI3MDAiIHN0eWxlPSJpc29sYXRpb246aXNvbGF0ZSI+PHRzcGFuIHg9IjAiIHk9IjAiPjEyMzwvdHNwYW4+PC90ZXh0PjwvZz48L3N2Zz4=";
export { SvgIconCvc as ReactComponent };